<a class="card-block copo-clickable" mat-ripple [routerLink]="['/fastlane/prototype/card', displayedFastlaneItems.id]">

	<div class="fastlane-list-card-header">
		<span class="fastlane-list-card-header-title">{{ fastlane.customerRequestName }}</span>
		<span class="fastlane-list-card-header-ton"
			[matTooltip]="displayedFastlaneItems.quantity ? (displayedFastlaneItems.quantity | copoNumber:'weight':'t' ) : underscore">{{
				displayedFastlaneItems.quantity ? (displayedFastlaneItems.quantity | copoNumber:'weight':'t' ) : underscore }}</span>
	</div>
	<div class="fastlane-list-card-informations-block">
		<div class="fastlane-list-card-information-block">
			<span class="fastlane-card-label" translate>eoffer.status</span>
			<span class="fastlane-card-value">{{displayedFastlaneItems.status}}</span>
		</div>
		<div class="fastlane-list-card-information-block">
			<span class="fastlane-card-label" translate>dashboard.steelgrade</span>
			<span class="fastlane-card-value" [matTooltip]="displayedFastlaneItems.steelGrade">{{ displayedFastlaneItems.steelGrade
				}}</span>
		</div>
	</div>
	<div class="fastlane-list-card-informations-block">
		<div class="fastlane-list-card-information-block">
			<span class="fastlane-card-label" translate>application.procurement.supplier.rfqNumber</span>
			<span class="fastlane-card-value" [matTooltip]="displayedFastlaneItems.supplierRfqNumber">{{ displayedFastlaneItems.supplierRfqNumber
				}}</span>
		</div>

		<div class="fastlane-list-card-information-block">
			<span class="fastlane-card-label" translate>eoffer.dimension.mm</span>
			<span class="fastlane-card-value" [matTooltip]="displayedFastlaneItems.dimension">{{
				displayedFastlaneItems.dimension }}</span>
		</div>
		<div class="fastlane-list-card-information-block">
			<span class="fastlane-card-label" translate>order-tracking.form</span>
			<span class="fastlane-card-value">{{fastlane.form}}</span>
		</div>
	</div>
</a>